import { buildRoute } from 'app/lazy-routing/build-route'
export const routes = [
  buildRoute({
    path: '/',
    factory: () => import('pages/home'),
    state: 'authenticated',
    defaultNavigation: 'activity-list',
    children: [
      {
        path: 'activity-list',
        factory: () => import('pages/activity-list/activity-list'),
        state: 'authenticated',
      },
      {
        path: 'activity-list/:id',
        factory: () => import('pages/activity-list/details/details'),
        state: 'authenticated',
      },
      {
        path: 'accounts',
        factory: () => import('pages/accounts/accounts'),
        state: 'authenticated',
      },
      {
        path: 'accounts/:id',
        factory: () => import('pages/accounts/details/details'),
        state: 'authenticated',
      },
      {
        path: 'client-data',
        factory: () => import('pages/client-data/client-data'),
        state: 'authenticated',
      },
      {
        path: 'services',
        factory: () => import('pages/services/services'),
        state: 'authenticated',
      },
      {
        path: 'user-manual',
        factory: () => import('pages/user-manual/user-manual'),
        state: 'authenticated',
      },
      {
        path: 'black-list',
        factory: () => import('pages/black-list/black-list'),
        state: 'authenticated',
      },
      {
        path: 'mail-templates',
        factory: () => import('pages/mail-templates'),
        state: 'authenticated',
        children: [
          {
            path: ':projectName',
            factory: () => import('pages/view-template'),
            state: 'authenticated',
          },
        ],
      },
      {
        path: 'edit-template/:projectName/:id?',
        factory: () => import('pages/mail-editor'),
        state: 'authenticated',
      },
    ],
  }),

  buildRoute({
    path: 'unsubscribe',
    factory: () => import('pages/unsubscribe'),
    state: 'unauthenticated',
  }),
]
